import React from 'react';
import LocationPicker from './LocationPicker';
import ViewAsSelector from './ViewAsSelector';

export default function Header({ session, onSignOut }) {
  return (
    <header style={{
      height: 56,
      background: '#fff',
      borderBottom: '1px solid #E5E7EB',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px',
      position: 'sticky',
      top: 0,
      zIndex: 30,
    }}>
      {/* Left: logo (visible on mobile, hidden on desktop when sidebar shows it) */}
      <div className="header-logo" style={{
        display: 'flex', alignItems: 'baseline', gap: 6,
      }}>
        <span style={{ fontSize: 17, fontWeight: 700, color: '#F07EA0', letterSpacing: 0.5 }}>
          Cutie Pie
        </span>
        <span style={{ fontSize: 11, color: '#9CA3AF', fontWeight: 400 }}>
          Operations
        </span>
      </div>

      {/* Center: location picker */}
      <LocationPicker />

      {/* Right: user */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {session && (
          <>
            <ViewAsSelector session={session} />
            <span style={{ fontSize: 13, color: '#6B7280', fontWeight: 500 }}>
              {session.opsFirstName || (session.employeeName?.includes('@') ? session.employeeName.split('@')[0] : session.employeeName)}
            </span>
            <button
              onClick={onSignOut}
              style={{
                fontSize: 13,
                color: '#6B7280',
                background: 'none',
                border: '1px solid #E5E7EB',
                borderRadius: 8,
                padding: '5px 12px',
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                transition: 'background 150ms ease',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              Sign Out
            </button>
          </>
        )}
      </div>
    </header>
  );
}
